import type { Pricing } from '@/types/checkout';
import { calculateTotalPrice } from '@/utils/pricing';
import { useTranslate } from '@/hooks/useTranslate';

export const TotalPrice = ({ pricing }: { pricing: Pricing }) => {
  const { t } = useTranslate();

  return (
    <div className="flex justify-between w-full mt-2 text-md md:text-base font-bold">
      <div>{t('total')}</div>
      <div>{calculateTotalPrice(pricing)}</div>
    </div>
  );
};
